import { SET_GYM_DATA, SET_GYM_ATTRIBUTE, SET_CHECKIN_POP_OPEN, SET_SCANNER_CHECKIN_TOKEN, SET_EXPIRING_TODAY_POP_OPEN, SET_EXPIRING_TODAY_DATA, SET_GYM_FEATURES_DATA, SET_GYM_FEATURES_OBJECT, SET_MEMBER_AT_RISK, SET_STATS } from '../types/types';

export const setGymData = (value) => {
  return {
    type: SET_GYM_DATA,
    payload: { data: value },
  };
};

export const setGymAttribute = (value) => {
  return {
    type: SET_GYM_ATTRIBUTE,
    payload: { data: value },
  };
};
export const setGymCategories = (value) => {
  return {
    type: "SET_GYM_CATEGORIES",
    payload: { data: value },
  };
};

export const setCheckinPopupOpen = (value) => {
  return {
    type: SET_CHECKIN_POP_OPEN,
    payload: { data: value },
  };
};
export const setScannerCheckinToken = (value) => {
  return {
    type: SET_SCANNER_CHECKIN_TOKEN,
    payload: { data: value },
  };
};
export const setExpiringTodayPopupOpen = (value) => {
  return {
    type: SET_EXPIRING_TODAY_POP_OPEN,
    payload: { data: value },
  };
};
export const setExpiringTodayData = (value) => {
  return {
    type: SET_EXPIRING_TODAY_DATA,
    payload: { data: value },
  };
};

export const setGymFeatures = (value) => {
  return {
    type: SET_GYM_FEATURES_DATA,
    payload: { data: value },
  };
};
export const setFeatures = (value) => {
  return {
    type: SET_GYM_FEATURES_OBJECT,
    payload: { data: value },
  };
};

export const setMemberAtRisk = (value) => {
  return {
    type: SET_MEMBER_AT_RISK,
    payload: { data: value },
  };
}

export const setStats = (value) => {
  return {
    type: SET_STATS,
    payload: { data: value },
  };
}